// ============================================================================
// DRILL REPORT SERVICE — Phase 1 stub (full SyutDrill integration ships in Phase 4)
// ============================================================================

import { post } from '../client/axiosClient';
import { reportEndpoints } from '../endpoints';
import type { PaginatedResponse, DrillReportRequest, DrillRow } from '../types';

class DrillReportService {
  async getDrill(req: DrillReportRequest): Promise<PaginatedResponse<DrillRow>> {
    const response = await post<any>(reportEndpoints.drill(), req);
    const raw = response.data;
    const pagedResult = raw?.data ?? {};
    return {
      success: raw?.success,
      message: raw?.message,
      data: pagedResult.items ?? [],
      pagination: {
        currentPage:    pagedResult.page ?? 1,
        pageSize:       pagedResult.pageSize ?? 25,
        totalPages:     pagedResult.totalPages ?? 0,
        totalItems:     pagedResult.totalCount ?? 0,
        hasNextPage:    pagedResult.hasNext ?? false,
        hasPreviousPage: pagedResult.hasPrevious ?? false,
      },
    };
  }
}

export const drillReportService = new DrillReportService();
export default drillReportService;
